export const FilesSelectedIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.875 3.75H9.375C7.25368 3.75 6.19302 3.75 5.53401 4.40901C4.875 5.06802 4.875 6.12868 4.875 8.25V12C4.875 14.1213 4.875 15.182 5.53401 15.841C6.19302 16.5 7.25368 16.5 9.375 16.5H10.3823C10.9955 16.5 11.3021 16.5 11.5777 16.3859C11.8534 16.2716 12.0701 16.0549 12.5037 15.6213L14.4963 13.6287C14.9299 13.1951 15.1466 12.9784 15.2609 12.7027C15.375 12.4271 15.375 12.1205 15.375 11.5073V8.25C15.375 6.12868 15.375 5.06802 14.716 4.40901C14.057 3.75 12.9963 3.75 10.875 3.75Z"
        stroke="#1453F5"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 16.125V15.375C11.25 13.9608 11.25 13.2537 11.6894 12.8144C12.1287 12.375 12.8358 12.375 14.25 12.375H15"
        stroke="#1453F5"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.875 14.2499C3.63236 14.2499 2.625 13.2426 2.625 11.9999V5.99988C2.625 3.87856 2.625 2.8179 3.28401 2.15889C3.94302 1.49988 5.00368 1.49988 7.125 1.49988H10.8753C12.1179 1.49989 13.1253 2.50726 13.1253 3.74989"
        stroke="#1453F5"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50073 9.75H10.5007M7.50073 6.75H12.7507"
        stroke="#1453F5"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M11.2485 15.3745L11.25 16.4995L15.375 12.3745H14.2485C12.8343 12.3745 12.1272 12.3745 11.6879 12.8139C11.2485 13.2531 11.2485 13.9603 11.2485 15.3745Z"
        fill="#1453F5"
      />
      <path
        opacity="0.4"
        d="M10.8735 3.74867H9.3735C7.25221 3.74867 6.19155 3.74867 5.53254 4.40768C4.87353 5.06669 4.87354 6.12736 4.87354 8.24868V11.9987C4.87354 12.9373 4.87354 13.6683 4.93062 14.2487H4.87354C3.6309 14.2487 2.62354 13.2413 2.62354 11.9987V5.99866C2.62354 3.87733 2.62354 2.81668 3.28255 2.15767C3.94156 1.49866 5.00221 1.49866 7.12353 1.49866H10.8738C12.1164 1.49866 13.1238 2.50604 13.1238 3.74867V3.80579C12.5434 3.74867 11.8123 3.74867 10.8735 3.74867Z"
        fill="#1453F5"
      />
    </svg>
  );
};
